export default {
  LDAP: 'LDAP',
  SAML: 'SAML',
  WINNT: 'WINNT',
};
